import FunctionalityLib from "./FunctionalityLib";
export default class FunctionalityService {
  public static library = FunctionalityLib;
  public static targetableDictionary: Dictionary<any> = {};

  public static getTarget(targetId: string) {
    if (FunctionalityService.targetableDictionary[targetId]) {
      return FunctionalityService.targetableDictionary[targetId];
    } else {
      let target = window.FormEngine.form.controls.get(targetId);
      if (!target) {
        target = window.FormEngine.form.sections.get(targetId);
      }
      if (!target) {
        console.log("getTarget - could not resolve target: ", targetId);
      } else {
        FunctionalityService.targetableDictionary[targetId] = target;
      }
      return target;
    }
  }
  public static res(attrName: string, func: IFunctionalityConfig, $s: { [key: string]: any }) {
    let temp = func.data[attrName] ? func.data[attrName] : "";
    if (temp == "") {

      if ($s.$rule.data[attrName]) {
        temp = $s.$rule.data[attrName];
      }
      if (temp !== undefined && temp != "")
        return temp;
      if (func.mapping[attrName]) {
        temp = $s.$rule.data[func.mapping[attrName]];
      }
      if (temp !== undefined && temp != "")
        return temp;
      if ($s.$rule.functionStack) {
        for (let fIndex in $s.$rule.functionStack) {
          let rule = $s.$rule.functionStack[fIndex];
          if (rule.ruleStack) {
            let parentIndex = rule.ruleStack.findIndex((item: any, index: number) => {
              return item.id === func.id;
            });
            if (rule.functionName == "rule" && parentIndex !== -1) {
              temp = rule.data[func.mapping[attrName]];
              if (temp !== undefined && temp !== "") {
                return temp;
              }
            }
          }
        }
      }
    }
    return temp;
  }
  public static builder(funcStack: [IFunctionalityConfig], $s: { [key: string]: any }) {
    let engine = window.FormEngine;
    //console.log(funcStack);
    return function () {
      for (let funcIndex in funcStack) {
        let func = funcStack[funcIndex];
        if (func.function) {
          func.function.call(engine, func, $s);
        } else {
          if (FunctionalityService.library[func.functionName]) {
            //      console.log("Calling functionality name:",func.functionName,func);
            FunctionalityService.library[func.functionName].call(engine, func, $s);
          } else {
            console.log("Trying to register non working functionality.", func);
          }
        }
      }
    };
  }
}
